import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const FinanceManager = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading } = useFilterOptions(VOFilterType.FINANCE_MANAGER);

  const mappedOptions = options.map(({ label, value }) => ({ label, value }));

  return (
    <AutocompleteField
      multiple
      size="small"
      loading={loading}
      control={control}
      disableCloseOnSelect
      name="FINANCE_MANAGER"
      options={mappedOptions}
      disabled={!mappedOptions.length}
      textFieldProps={{
        size: 'small',
        variant: 'outlined',
        label: 'Finance Manager',
      }}
    />
  );
};
